"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphabetString = void 0;
exports.alphabetString = 'abcdefghijklmnopqrstuvwxyz';
